import { calculateBarCapacity as calculateBarTotalCapacity } from "../../pages/reservas/components/barCapacity";
import { appendRecordatorios } from "../recordatorios/recordatorios";

/** FormData the bar create/update endpoints expect (shared by the bar form and the guided first run). */
export function buildBarFormData(barForm) {
	const fd = new FormData();
	if (barForm.barId) fd.append("barId", barForm.barId);
	fd.append("name", barForm.name || "");
	if (barForm.slug) fd.append("slug", barForm.slug);
	fd.append("shortDescription", barForm.shortDescription || "");
	fd.append("description", barForm.description || "");
	fd.append("address", barForm.address || "");
	// Omit blank/non-numeric coordinates so the backend can geocode legacy or
	// manually edited addresses instead of treating empty values as explicit.
	if (
		barForm.lat !== "" &&
		barForm.lat != null &&
		Number.isFinite(Number(barForm.lat))
	) {
		fd.append("lat", String(barForm.lat));
	}
	if (
		barForm.lng !== "" &&
		barForm.lng != null &&
		Number.isFinite(Number(barForm.lng))
	) {
		fd.append("lng", String(barForm.lng));
	}
	if (barForm.cityid) fd.append("cityid", barForm.cityid);
	if (barForm.stateid) fd.append("stateid", barForm.stateid);
	fd.append("reservationMode", barForm.reservationMode || "free");
	fd.append("depositAmount", String(barForm.depositAmount || 0));
	fd.append("slotDurationMinutes", String(barForm.slotDurationMinutes || 120));
	fd.append(
		"reservationWindowDays",
		String(barForm.reservationWindowDays || 6),
	);
	fd.append("maxPartySize", String(barForm.maxPartySize || 10));
	fd.append(
		"cancellationPolicyHours",
		String(barForm.cancellationPolicyHours || 24),
	);
	// Only the edit form carries it; the guided create flow appends its own value afterwards.
	if (barForm.onlineBookingEnabled !== undefined) {
		fd.append("onlineBookingEnabled", String(barForm.onlineBookingEnabled === true));
	}
	fd.append("isFeatured", String(Boolean(barForm.isFeatured)));
	fd.append(
		"totalCapacity",
		String(calculateBarTotalCapacity(barForm.zones)),
	);
	fd.append("contactPhone", barForm.contactPhone || "");
	fd.append("contactEmail", barForm.contactEmail || "");
	fd.append("minAdvanceMinutes", String(barForm.minAdvanceMinutes || 120));
	fd.append(
		"cancellationAllowed",
		String(Boolean(barForm.cancellationAllowed)),
	);
	fd.append("toleranceMinutes", String(barForm.toleranceMinutes || 15));
	appendRecordatorios(fd, barForm);
	fd.append("additionalNotes", barForm.additionalNotes || "");
	fd.append("zonePricingEnabled", String(Boolean(barForm.zonePricingEnabled)));
	fd.append("instagram", barForm.instagram || "");
	fd.append("website", barForm.website || "");
	fd.append("existingGallery", JSON.stringify(barForm.existingGallery || []));
	const amenities = String(barForm.amenitiesText || "")
		.split(",")
		.map((item) => item.trim())
		.filter(Boolean);
	fd.append("amenities", JSON.stringify(amenities));
	fd.append(
		"openingHours",
		JSON.stringify(
			(barForm.openingHours || []).map((row) => ({
				weekday: Number(row.weekday),
				enabled: Boolean(row.enabled),
				open: row.open || "",
				close: row.close || "",
			})),
		),
	);
	fd.append(
		"zones",
		JSON.stringify(
			(barForm.zones || []).map((z) => ({
				name: z.name,
				tableCount: Number(z.tableCount || 1),
				tableCapacity: Number(z.tableCapacity || 4),
				price: Number(z.price || 0),
				priceEnabled: Boolean(z.priceEnabled),
			})),
		),
	);
	if (barForm.imageFile instanceof File) {
		fd.append("image", barForm.imageFile);
	}
	if (Array.isArray(barForm.galleryFiles)) {
		barForm.galleryFiles.forEach((file) => {
			fd.append("galleryimage", file);
		});
	}
	return fd;
}
